export enum RolesEnum{
    SuperAdmin=1,
    HRO=2,
    HRConsultant=3,
    GuestHRC=4
}